// 标签页
function Tab(options) {
	this.init(options)
}

Object.assign(Tab.prototype, {
	init(options = {}) {
		this.options = Object.assign({}, options)
		// data
		var { Vue } = this.options

		this.listeners = [] // 监听器
		this.pv = 0 // 访问次数
		this.cached = false // vnode是否缓存
		
		// getters
		Object.keys(this.options).forEach(k => {
			Object.defineProperty(this, k, {
				enumerable: true,
				configurable: false,
				get: () => this.options[k]
			})
		})
	},

	postMessage(message, targetOrigin = "*", answer) {
		this.tabManager.postMessage(this, message, targetOrigin, answer)
	},

	addMessageListener(callback) {
		this.listeners.push(callback)
	},

	removeMessageListener(callback) {
		var index = this.listeners.indexOf(callback)

		if (index >= 0) {
			this.listeners.splice(index, 1)
		}
	},

	notify(event) {
		// event 包含 message以及origin
		this.listeners.forEach(cb => cb(event))
	},

	// 是否重复访问
	isRepeat(){
		return this.pv > 1
	},

	// 是否重复访问缓存
	isRepeatCache(){
		return this.isRepeat() && this.cached
	},
})

export default Tab